import React from 'react';
import PropTypes from 'prop-types';

const VolumeHighIcon = ({ className }) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M2 14.5002L2 10.5002C2 8.50021 3 7.50021 5 7.50021H6.43C6.8 7.50021 7.17 7.39021 7.49 7.20021L10.41 5.37021C12.93 3.79021 15 4.94021 15 7.91021L15 17.0902C15 20.0702 12.93 21.2102 10.41 19.6302L7.49 17.8002C7.17 17.6102 6.8 17.5002 6.43 17.5002H5C3 17.5002 2 16.5002 2 14.5002Z" stroke="#464646" strokeWidth="1.824" />
            <path d="M18 16.5C19.78 14.13 19.78 10.87 18 8.5" stroke="#464646" strokeWidth="1.824" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.8301 19C22.7201 15.15 22.7201 9.85 19.8301 6" stroke="#464646" strokeWidth="1.824" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

VolumeHighIcon.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

VolumeHighIcon.defaultProps = {
    className: '', // Default to an empty string
};

export default VolumeHighIcon;